///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/components/editors/email/defaults"/>

interface ReturnedObject {
    template: string,
    align: string,
    options: {
        defaultName: string,
        placeholder: string,
        pattern: any,
        css: any
    }
}

export = {
    get: function (): ReturnedObject {
        return {
            template: "editors-email-default",
            align: 'left',
            options: {
                defaultName: "editor-email",
                placeholder: null,
                pattern: null,
                css: null
            }
        };
    }
};